var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('serviceList'),_c('serviceAdd'),_c('saveBtn',{staticClass:"saveBtn",attrs:{"callback":function() {
        _vm.setSave();
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }